/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROGOODS", "190")


  
    
export interface API20450Item {
  
  /**  */
  categoryNo: string;
  
  /**  */
  categoryName: string;
  
  /**  */
  level: number;
  
  /**  */
  sortNum: number;
  
  /**  */
  parentNo: string;
  
  /**  */
  icon: string;
  
  /**  */
  isLeaf: number;
  
  /**  */
  hasChild: number;
  
  /**  */
  categoryNoPath: string;
  
};
    
  



export interface API20450Req {
  
  /** 父类目编号(String) 默认传 0 查询一级类目 */
  parentNo?: string;
    
};



export interface API20450Res {
  /** T  */
  list: API20450Item[];
  /**   */
  totalNumber: number;
  /**   */
  totalPage: number;
  /**   */
  rowId: string;
  /**   */
  hasNext: boolean;
  /**   */
  pageSize: number;
  /**   */
  pageIndex: number;
  
};


// 20450 【类目管理】- 类目树查询

export interface IUseGetAPI20450Return {
  /** 【类目管理】- 类目树查询: 接口请求状态 */
  isAPI20450Loading: boolean;
  /** 【类目管理】- 类目树查询: 接口请求返回数据 */
  dataAPI20450: API20450Res;
  /**  【类目管理】- 类目树查询: 接口数据请求方法 */
  fetchAPI20450Data:  (inputs: API20450Req, config?: YWRequestConfig) => Promise<API20450Res>;
  /** 【类目管理】- 类目树查询: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI20450 = ():IUseGetAPI20450Return => {
  let isMount = true;
  const [isAPI20450Loading, setIsAPI20450Loading] = useState(false);
  const [dataAPI20450, setDataAPI20450] = useState<API20450Res>({} as API20450Res);
  const requestUrl = `${basePath}/ywwl-item-center-admin/category/tree/list/v1`;

  const fetchAPI20450Data = async (inputs: API20450Req, config?: YWRequestConfig): Promise<API20450Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20450Req>) || {}) as API20450Req;
    
  
    if ( isMount ) {
      setIsAPI20450Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API20450Res>(`${basePath}/ywwl-item-center-admin/category/tree/list/v1?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI20450(res || {} as API20450Res);
        setIsAPI20450Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20450Loading(false);
      }
      return false as unknown as API20450Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20450Loading,
    dataAPI20450,
    fetchAPI20450Data,
    requestUrl,
  }
}

